import React from 'react';
import { Text } from '@qga/roo-ui/components';
import { differenceInCalendarDays } from 'lib/date';
import pluralize from 'pluralize';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';

interface NumberOfNightsProps {
  checkIn: Date;
  checkOut: Date;
  color?: string;
  font?: string;
  fontWeight?: number;
}

const OfferBreakdownText = styled(Text)`
  ${themeGet('card.propertyCard.offerBreakdown')}
`;

const NumberOfNights = ({ checkIn, checkOut, color, font, ...rest }: NumberOfNightsProps) => {
  const totalDays = differenceInCalendarDays(checkOut, checkIn);
  return (
    <OfferBreakdownText data-testid="numberOfNights" {...rest} color={color || 'greys.charcoal'} fontSize={font || '18px'} fontWeight={400}>
      {pluralize('night', totalDays, true)}
    </OfferBreakdownText>
  );
};

export default NumberOfNights;
